import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import type {
  Condition,
  Material,
  Product,
  ProductDetail,
  ProductFacets,
  ProductListResponse,
  ProductQueryParams,
  TreeWidth,
} from '../models/product.model';

export interface CreateProductPayload {
  title: string;
  brandId: string;
  disciplineId: string;
  model?: string;
  description: string;
  seatSizeInches: number;
  treeWidth: TreeWidth;
  colourId: string;
  material: Material;
  condition: Condition;
  year?: number;
  flapLength?: string;
  priceAmountCents: number;
  addressId: string;
  localPickupAvailable: boolean;
  deliveryAvailable: boolean;
  images?: string[];
}

@Injectable({ providedIn: 'root' })
export class ProductsService {
  constructor(private readonly http: HttpClient) {}

  findAll(query: ProductQueryParams): Observable<ProductListResponse> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(query)) {
      if (value === undefined || value === null || value === '') continue;
      params = params.set(key, Array.isArray(value) ? value.join(',') : String(value));
    }
    return this.http.get<ProductListResponse>(`${API_BASE_URL}/products`, { params });
  }

  facets(): Observable<ProductFacets> {
    return this.http.get<ProductFacets>(`${API_BASE_URL}/products/facets`);
  }

  findOne(id: string): Observable<ProductDetail> {
    return this.http.get<ProductDetail>(`${API_BASE_URL}/products/${id}`);
  }

  findMine(): Observable<Product[]> {
    return this.http.get<Product[]>(`${API_BASE_URL}/products/mine`);
  }

  create(payload: CreateProductPayload): Observable<Product> {
    return this.http.post<Product>(`${API_BASE_URL}/products`, payload);
  }

  update(id: string, payload: CreateProductPayload): Observable<Product> {
    return this.http.patch<Product>(`${API_BASE_URL}/products/${id}`, payload);
  }

  publish(id: string): Observable<Product> {
    return this.http.patch<Product>(`${API_BASE_URL}/products/${id}/publish`, {});
  }

  archive(id: string): Observable<unknown> {
    return this.http.delete(`${API_BASE_URL}/products/${id}`);
  }
}
